const atify = (text: string): string => {
    if (text && text.length > 0 && text.startsWith('@')) {
        return text;
    }

    return '@' + text;
};

export default atify;
